
	import {
		footPrint,
		delFootprint
	} from "@/api/member/member"
	import {
		mapGetters
	} from "vuex"

	export default {
		name: "footprint",
		components: {},
		data: () => {
			return {
				timesArr: [],
				footPrintData: [],
				loading: true,
				yes: true
			}
		},
		created() {
			this.getFootPrintData()
		},
		computed: {
			...mapGetters(["defaultGoodsImage"])
		},
		mounted() {
			let self = this;
			setTimeout(function() {
				self.yes = false
			}, 300)
		},
		methods: {
			/**
			 * 商品列表
			 */
			getFootPrintData() {
				footPrint({
						page: 1,
						page_size: 0
					})
					.then(res => {
						var data = res.data.list
						this.footPrintData = []
						this.timesArr = []

						for (let i = 0; i < data.length; i++) {
							var date = timeStampTurnTime(data[i].browse_time).split(" ")[0]
							var flag = util.inArray(date, this.timesArr)

							if (flag == -1) {
								this.timesArr.push(date)
							}

							var goods = {}
							goods.id = data[i].id
							goods.sku_id = data[i].sku_id
							goods.browse_time = date
							goods.goods_image = data[i].sku_image.split(",")[0]
							goods.goods_name = data[i].sku_name
							goods.goods_price = data[i].discount_price

							this.footPrintData.push(goods)
						}
						this.loading = false
					})
					.catch(err => {
						this.loading = false
					})
			},
			/**
			 * 圖片加載失敗
			 */
			imageError(index) {
				this.footPrintData[index].goods_image = this.defaultGoodsImage
			},
			/**
			 * 刪除某個足跡
			 */
			deleteFootprint(id) {
				delFootprint({
						id: id
					})
					.then(res => {
						this.loading = false
						this.getFootPrintData()
						this.$message({
							message: res.message,
							type: "success"
						})
					})
					.catch(err => {
						this.loading = false
						this.$message.error(err.message)
					})
			},
			mouseenter(scope) {
				this.$set(scope, "del", true)
			},
			mouseleave(scope) {
				this.$set(scope, "del", false)
			}
		}
	}
